module.exports = __webpack_public_path__ + "static/img/4.e3b4d1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/4.png
// module id = XHhg
// module chunks = 5